import React from 'react';
import { List } from 'immutable';

import {
  CoreLink,
  Node,
} from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphSelectedContent = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed']);
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], 'Lees meer');
  const entities = entity.getIn(['field_content_items'], List());

  return (
    <div className="ParagraphSelectedContent">
      <Container>

        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="row">

              <div className="col-12">
                <div className="ParagraphSelectedContent__title">
                  <h2>{title}</h2>
                </div>

                {text && (
                  <div className="ParagraphSelectedContent__text">
                    <WysiwygField
                      property="schema:text"
                      html={text}
                    />
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </Container>

      <Container>
        <div className="ContentSlider">
          {/* TODO add content sldier of entities here */}
          <div className="row">
            {entities.map((entity, index) => {
              const id = entity.getIn(['entity', 'nid', '0', 'value']);
              const uuid = entity.getIn(['entity', 'uuid', 0, 'value']);
              const langcode = entity.getIn(['entity', 'langcode', 0, 'value']);
              const className = 'col-12 col-md-6 col-lg-4';

              return (
                <div key={`${uuid}:${langcode}`} className={className}>
                  <Node
                    id={id}
                    isActivePath
                    entity={entity.get('entity')}
                    viewMode="teaser"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Container>

      {linkUrl && (
        <Container>
          <div className="row">
            <div className="col-12">
              <div className="ParagraphSelectedContent__link">
                <CoreLink className="Button Button--secondary" to={linkUrl}>
                  {linkTitle} <i className="icon icon-arrow-right" />
                </CoreLink>
              </div>
            </div>
          </div>
        </Container>
      )}
    </div>
  );
};

export default ParagraphSelectedContent;
